import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Modal,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { styled } from "@mui/system";
import { API_URI } from "../../constants/GlobalConstants";

const StyledModalBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  backgroundColor: theme.palette.mode === "dark" ? "#1e293b" : "#fff",
  borderRadius: "8px",
  boxShadow: theme.shadows ? theme.shadows[5] : "0 4px 6px rgba(0, 0, 0, 0.1)",
  padding: "24px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));

const AddTemplateModal = ({ userInfo, onTemplateAdded, onSnackbar }) => {
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    type: "",
    htmlContent: "",
  });

  // Handle modal open/close
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
    setFormData({ name: "", description: "", type: "", htmlContent: "" });
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle template addition
  const handleAddTemplate = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${API_URI}/api/invoices/templates`,
        formData,
        { headers: { Authorization: `Bearer ${userInfo.token}` } }
      );
      onTemplateAdded(response.data.template);
      onSnackbar({
        open: true,
        message: "Template added successfully",
        severity: "success",
      });
      handleCloseModal();
    } catch (error) {
      onSnackbar({
        open: true,
        message: "Failed to add template",
        severity: "error",
      });
    }
    setLoading(false);
  };

  return (
    <>
      <Button variant="contained" onClick={handleOpenModal}>
        Add Template
      </Button>
      <Modal open={openModal} onClose={handleCloseModal}>
        <StyledModalBox>
          <Typography
            variant="h6"
            sx={{ color: (theme) => (theme.palette.mode === "dark" ? "#e2e8f0" : "#1e293b") }}
          >
            Add New Template
          </Typography>
          <TextField
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            fullWidth
            sx={{ input: { color: (theme) => (theme.palette.mode === "dark" ? "#e2e8f0" : "#1e293b") } }}
          />
          <TextField
            label="Description"
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            fullWidth
            sx={{ input: { color: (theme) => (theme.palette.mode === "dark" ? "#e2e8f0" : "#1e293b") } }}
          />
          <FormControl fullWidth>
            <InputLabel sx={{ color: (theme) => (theme.palette.mode === "dark" ? "#e2e8f0" : "#1e293b") }}>
              Type
            </InputLabel>
            <Select
              name="type"
              value={formData.type}
              onChange={handleInputChange}
              sx={{ color: (theme) => (theme.palette.mode === "dark" ? "#e2e8f0" : "#1e293b") }}
            >
              <MenuItem value="Order-Based">Order-Based</MenuItem>
              <MenuItem value="Custom">Custom</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="HTML Content"
            name="htmlContent"
            value={formData.htmlContent}
            onChange={handleInputChange}
            multiline
            rows={10}
            fullWidth
            sx={{ textarea: { color: (theme) => (theme.palette.mode === "dark" ? "#e2e8f0" : "#1e293b") } }}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button variant="contained" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleAddTemplate}
              disabled={loading || !formData.name || !formData.type || !formData.htmlContent}
            >
              Save
            </Button>
          </Box>
        </StyledModalBox>
      </Modal>
    </>
  );
};

export default AddTemplateModal;